module.exports = __webpack_public_path__ + "static/media/boh_logo.4ede95e4.png";